<template>
  <div class="my-account" style="padding:24px">
    <div class="account-head">
      <div class="balance">
        <div class="title" style="padding:16px 24px;">
          <span style="color:rgba(51, 51, 51, 1);font-size:18px;font-weight:bold;">账户余额</span>
          <span @click="accountRecharge" style="float:right;width:88px;height:32px;border-radius:4px;line-height:32px;color:#fff;font-size:14px;text-align:center;background:rgba(34, 215, 187, 1);cursor:pointer">账户充值</span>
        </div>
        <div style="clear:both"></div>
        <a-divider style="margin:0 0 24px 0" />
        <div class="num" style="padding:41px 24px 0 24px;color:rgba(34, 215, 187, 1);font-size:32px;">
          <span style="">￥</span>
          <span style="">{{accountBalance.money}}</span>
        </div>
        <div class="credit">(信用额度：{{accountBalance.creditMoney}}元)</div>
      </div>
      <div class="survey">
        <div class="title" style="padding:16px 24px">
          <span style="color:rgba(51, 51, 51, 1);font-size:18px;font-weight:bold">通道概况</span>
          <router-link to="/Account/PathManage">
            <span @click="activateChannel" style="float:right;width:88px;height:32px;border-radius:4px;line-height:32px;color:#fff;font-size:14px;text-align:center;background:rgba(34, 215, 187, 1);cursor:pointer">激活通道</span>
          </router-link>
        </div>
        <div style="clear:both"></div>
        <a-divider style="margin:0 0 65px 0" />
        <div style="text-align:center;">
          <a-row>
            <a-col :span="8">
              <div style="color:rgba(34, 215, 187, 1);font-size:32px;font-weight:bold">{{pathInfo.activeCount}}</div>
              <div style="color:rgba(170, 170, 170, 1);font-size:14px;">激活通道数量</div>
              
            </a-col>
            <a-col :span="8">
              <div style="color:rgba(34, 215, 187, 1);font-size:32px;font-weight:bold">{{pathInfo.totalCount}}</div>
              <div style="color:rgba(170, 170, 170, 1);font-size:14px;">机器人总数</div>
             
            </a-col>
            <a-col :span="8">
              <router-link :to="{path:'/Account/PathManage',query:{num:pathInfo.nearOvertimeCount}}">
                <div style="color:rgba(34, 215, 187, 1);font-size:32px;font-weight:bold">{{pathInfo.nearOvertimeCount}}</div>
              </router-link>
              <div style="color:rgba(170, 170, 170, 1);font-size:14px;">近七天快到期的机器人数量</div>
              
            </a-col>
          </a-row>
        </div>
      </div>
      <div class="bill">
        <div class="title" style="padding:16px 24px;border-bottom:1px solid #e8e8e8">
          <span class="month" style="color:rgba(51, 51, 51, 1);font-size:18px;font-weight:bold">月账单</span>
          <div style="line-height:40px;">
            <span :class="{'active':monthAccount=='COST'}" @click="viewMonth('COST')" style="display:inline-block;height:36px;">消费</span>
            <span :class="{'active':monthAccount=='RECHARGE'}" @click="viewMonth('RECHARGE')" style="display:inline-block;height:36px;">充值</span>
          </div>
        </div>
        <div>
          <div>
            <div id="myChart1" :style="{width: '100%', height: '190px'}"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="account-body">
      <div class="content-tab">
        <div class="tab-title" style="padding:24px 24px 0;">
          <span @click="viewTab('consumption')" :class="{'active':currentTab=='consumption'}">消费记录</span>
          <span @click="viewTab('recharge')" :class="{'active':currentTab=='recharge'}">充值记录</span>
        </div>
        <a-divider style="margin:0px" />
        <div v-if="currentTab=='consumption'" style="padding:24px">
          <a-row style="margin-bottom:16px;">
            <a-col :span="6">
              <div style="display:inline-block;">
                <div style="margin-bottom:8px;">交易类型：</div>
                <a-select style="width:190px"
                  @change="consumptionChange"
                  :defaultValue="defaultConsumptionData"
                  :key="defaultConsumptionData"
                  v-model="consumptionObj.type"
                >
                  <a-select-option value=''>全部</a-select-option>
                  <a-select-option value='CHANNEL'>激活通道</a-select-option>
                  <a-select-option value='EXTRA_SERVER'>增值服务</a-select-option>
                </a-select>
              </div>
            </a-col>
            <a-col :span="6">
              <div style="display:inline-block;margin-left:24px">
                <div style="margin-bottom:8px;">交易时间：</div>
                <a-range-picker
                  :locale="locale"
                  style="width:280px"
                  @change="onChangeConsumptionTime"
                  :placeholder="[consumptionObj.minCreateTime, consumptionObj.maxCreateTime]"
                  :showTime="{
                    hideDisabledOptions: true,
                    defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
                  }"
                  format="YYYY-MM-DD"
                />
              </div>
            </a-col>
            <a-col :span="6">
              <div style="display:inline-block;margin-left:24px">
                <div style="margin-bottom:8px;">状态：</div>
                <a-select style="width:190px"
                  @change="consumptionStateChange"
                  :defaultValue="defaultConsumptionState"
                  :key="defaultConsumptionState"
                  v-model="consumptionObj.status"
                >
                  <a-select-option value=''>全部</a-select-option>
                  <a-select-option value='NOT_PAY'>待支付</a-select-option>
                  <a-select-option value='SUCCESS'>支付成功</a-select-option>
                  <a-select-option value='REJECT'>驳回</a-select-option>
                  <a-select-option value='FAIL'>支付失败</a-select-option>
                </a-select>
              </div>
            </a-col>
            <a-col :span="6">
              <span @click="downloadExcel()" style="float:right;color:#fff;background:rgba(34, 215, 187, 1);width:120px;height:32px;line-height:32px;text-align:center;border-radius:4px;font-size:14px;cursor:pointer;margin-top:30px;margin-left:16px;">导出消费记录</span>
              <span @click="queryConsumptionData(1)" style="float:right;color:#fff;background:rgba(34, 215, 187, 1);width:80px;height:32px;line-height:32px;text-align:center;border-radius:4px;font-size:14px;cursor:pointer;margin-top:30px">查询</span>
            </a-col>
          </a-row>
          <div>
            <a-table :data-source="costData" :pagination='false' :loading="ifShowLoading">
              <a-table-column key="id" title="id" data-index="id" />
              <a-table-column key="typeStr" title="交易类型" data-index="typeStr" />
              <a-table-column key="money" title="消费金额（元）" data-index="money" />
              <a-table-column key="createTime" title="交易时间" data-index="createTime" />
              <a-table-column key="setMenuName" title="套餐名称" data-index="setMenuName" />
              <a-table-column key="channelCount" title="通道数量" data-index="channelCount" />
              <a-table-column key="statusStr" title="状态描述" data-index="statusStr" />
              <a-table-column key="detail" title="消费明细" data-index="detail">
                <template slot-scope="text, record">
                  <!-- <div :title="record.detail">
                    {{record.detail.length>50?record.detail.substring(0,50)+'...':record.detail}}
                  </div> -->
                  <a-button type="primary" @click="queryDetail(text, record.detail)">
                    查看详情
                  </a-button>
                </template>
              </a-table-column>
            </a-table>
            <div style="font-size:14px;color:rgba(51, 51, 51, 1);float:left;margin-top:16px;font-weight:bold">
              <span>总计：</span>
              <span>{{totalPrice1}}</span>
              <span>元</span>
              <span style="margin-left:24px;">总笔数：{{costData.length}}</span>
            </div>
            <a-pagination
              style="float:right;margin:16px 0 24px 0"
              v-model="consumptionObj.current"
              :page-size-options="pageSizeOptions"
              :total="total1"
              show-size-changer
              :page-size="consumptionObj.size"
              @showSizeChange="onShowSizeChange1"
              @change="onChangeSample1"
            >
              <template slot="buildOptionText" slot-scope="props">
                <span>{{ props.value }}条/页</span>
              </template>
            </a-pagination>
          </div>
        </div>
        <div v-if="currentTab=='recharge'" style="padding:24px">
          <a-row style="margin-bottom:16px;">
            <a-col :span="12">
              <div style="margin-bottom:8px;">交易时间：</div>
              <a-range-picker
                :locale="locale"
                style="width:280px"
                @change="onChangeRechargeTime"
                :placeholder="[consumptionObj.minCreateTime, consumptionObj.maxCreateTime]"
                :showTime="{
                  hideDisabledOptions: true,
                  defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
                }"
                format="YYYY-MM-DD"
              />
            </a-col>
            <a-col :span="12">
              <span @click="queryRechargeData(1)" style="float:right;color:#fff;background:rgba(34, 215, 187, 1);width:80px;height:32px;line-height:32px;text-align:center;border-radius:4px;font-size:14px;cursor:pointer;margin-top:30px;">查询</span>
            </a-col>
          </a-row>
          <div>
            <a-table :data-source="rechargeData" :pagination='false' :loading="ifShowLoading">
              <a-table-column key="id" title="id" data-index="id" />
              <a-table-column key="money" title="消费金额（元）" data-index="money" />
              <a-table-column key="beforeMoney" title="充值前金额" data-index="beforeMoney" />
              <a-table-column key="afterMoney" title="充值后金额" data-index="afterMoney" />
            </a-table>
            <div style="font-size:14px;color:rgba(51, 51, 51, 1);float:left;margin-top:16px;font-weight:bold">
              <span>总计：</span>
              <span>{{totalPrice2}}</span>
              <span>元</span>
              <span style="margin-left:24px;">总笔数：{{rechargeData.length}}</span>
            </div>
            <a-pagination
              style="float:right;margin:16px 0 24px 0"
              v-model="rechargeObj.current"
              :page-size-options="pageSizeOptions"
              :total="total2"
              show-size-changer
              :page-size="rechargeObj.size"
              @showSizeChange="onShowSizeChange2"
              @change="onChangeSample2"
            >
              <template slot="buildOptionText" slot-scope="props">
                <span>{{ props.value }}条/页</span>
              </template>
            </a-pagination>
          </div>
        </div>
      </div>
    </div>
    <a-modal
      title="账户充值"
      :visible="rechargeModal"
      :footer="null"
      @ok="rechargeHandleOk"
      @cancel="rechargeHandleCancel"
    >
      <div>
        <div style="color:rgba(51, 51, 51, 1);font-size:18px;">如果您想充值账号余额，请联系我们</div>
        <div style="height:20px;margin-top:24px;padding-bottom:34px">
          <div style="float:right;">
            <span @click="hasKnown" style="display:inline-block;width:90px;height:34px;text-align:center;line-height:34px;background:rgba(34, 215, 187, 1);color:#fff;font-size:14px;border-radius:4px;cursor:pointer">我知道了</span>
          </div>
          
        </div>
      </div>
    </a-modal>
    <a-modal
      title="消费明细"
      :visible="ifShowCostDetail"
      :footer="null"
      @cancel="hideCostDetail"
    >
      <div>
        <div style="color:rgba(51, 51, 51, 1);font-size:18px;">{{costDetailData}}</div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
export default {
  name: 'MyAccount',
  props: {
    msg: String
  },
  data() {
    return {
      locale,
      monthAccount: 'COST',
      currentTab: 'consumption',
      rechargeModal: false,
      startTime2: '',
      endTime2: '',
      defaultConsumptionData: '全部',
      defaultConsumptionState: '全部',
      accountBalance: {},
      pathInfo: {},
      consumptionObj: {
        current: 1,
        size: 10,
        type: '全部',
        minCreateTime: '',
        status: '全部',
        maxCreateTime: '',
      },
      rechargeObj: {
        current: 1,
        size: 10,
        minCreateTime: '',
        maxCreateTime: '',
      },
      ifShowLoading: false,
      costData: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      pageSize1: 10,
      currentPage1: 1,
      total1: 0,
      pageSize2: 10,
      currentPage2: 1,
      total2: 0,
      rechargeData: [],
      totalPrice1: 0,
      totalPrice2: 0,
      ifShowCostDetail: false,
      costDetailData: ''
    };
  },
  methods: {
    moment,
    viewMonth(type) {
      this.monthAccount = type
      this.axios(
        {
          method:'get',
          url:'/api/statistic/account',
          params: {
            type: type,
          }
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          this.drawMonthlyBill(response.data.data)
        }else{
          this.$message.error(response.data.message);
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    viewTab(type) {
      this.currentTab = type
    },
    rechargeHandleOk() {
      this.rechargeModal = false;
    },
    rechargeHandleCancel() {
      this.rechargeModal = false;
    },
    accountRecharge() {
      this.rechargeModal = true;
    },
    onChangeConsumptionTime(date, dateString) {
      this.consumptionObj.minCreateTime = dateString[0]
      this.consumptionObj.maxCreateTime = dateString[1]
    },
    onChangeRechargeTime(date, dateString) {
      this.rechargeObj.minCreateTime = dateString[0]
      this.rechargeObj.maxCreateTime = dateString[1]
    },
    consumptionChange(value) {
      this.consumptionObj.type = value
    },
    consumptionStateChange(value) {
      this.consumptionObj.status = value
    },
    drawMonthlyBill(data){
      let dataX = [], dataY = []
      for(let i = 0; i < data.length; i++){
        dataX.push(data[i]['month'])
        dataY.push(data[i]['money'])
      }
      let myChart = this.$echarts.init(document.getElementById('myChart1'))
      myChart.setOption({
        xAxis: {
          type: 'category',
          data: dataX,
          axisLine: {
            lineStyle:{
              color:'#E0E0E0',//x轴的颜色
              width:1,//轴线的宽度  
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#939393'
            }
          },
        },
        tooltip : {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle:{
              color:'#E0E0E0',//x轴的颜色
              width:0,//轴线的宽度  
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#939393'
            }
          },
          splitLine:{  
            show:true  ,
            lineStyle:{
              color:'#eee',
              width: 1
            }
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: '15%',
          containLabel: true
        },
        series: [
          {
            data: dataY,
            type: 'line',
            smooth: true,
            symbol: 'circle',//折线点设置为实心点
            symbolSize: 4,   //折线点的大小
            itemStyle: {
              normal: {
                color: "#22d7bb",//折线点的颜色
                lineStyle: {
                  color: "#22d7bb"//折线的颜色
                },
              }
            },
            label: {
              normal: {
                  show: true,
                  position: 'top'
              }
            },
          }
        ]
      });
    },
    queryAccountBalance() {
      this.axios(
        {
          method:'get',
          url:'/api/account/money',
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          this.accountBalance = response.data.data
        }else{
          this.$message.error(response.data.message);
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    queryChanneloverview() {
      this.axios(
        {
          method:'get',
          url:'/api/statistic/channel',
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          this.pathInfo = response.data.data
        }else{
          this.$message.error(response.data.message);
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    queryConsumptionData(type) {
      //type为1的时候需要查询总计，type为2的时候不需要
      this.axios({
        url: '/api/account/costRecord/list', 
        method: 'get',
        params: {
          current: this.consumptionObj.current,
          size: this.consumptionObj.size,
          type: this.consumptionObj.type=='全部'?'':this.consumptionObj.type,
          minCreateTime: this.consumptionObj.minCreateTime=='开始时间'?'':this.consumptionObj.minCreateTime,
          status: this.consumptionObj.status=='全部'?'':this.consumptionObj.status,
          maxCreateTime: this.consumptionObj.maxCreateTime=='结束时间'?'':this.consumptionObj.maxCreateTime,
        }
      })
      .then(response=> {
        if(response.data.code == 0){
          this.costData = response.data.data.records
          this.total1 = response.data.data.total
        }else{
          this.$message.error(response.data.message);
        }
      })
      .catch(error=> {
        console.log(error)
      })
      if(type == 1){
        this.axios({
          url: '/api/account/costRecord/totalMoney', 
          method: 'get',
          params: {
            type: this.consumptionObj.type=='全部'?'':this.consumptionObj.type,
            minCreateTime: this.consumptionObj.minCreateTime=='开始时间'?'':this.consumptionObj.minCreateTime,
            maxCreateTime: this.consumptionObj.maxCreateTime=='结束时间'?'':this.consumptionObj.maxCreateTime,
          }
        })
        .then(response=> {
          if(response.data.code == 0){
            this.totalPrice1 = response.data.data.money
          }else{
            this.$message.error(response.data.message);
          }
        })
        .catch(error=> {
          console.log(error)
        })
      }
    },
    queryRechargeData(type) {
      //type为1的时候需要查询总计，type为2的时候不需要
      this.axios({
        url: '/api/account/recharge/list', 
        method: 'get',
        params:{
          current: this.currentPage2,
          size: this.pageSize2,
          minCreateTime: this.rechargeObj.minCreateTime=='开始时间'?'':this.rechargeObj.minCreateTime,
          maxCreateTime: this.rechargeObj.maxCreateTime=='结束时间'?'':this.rechargeObj.maxCreateTime,
        }
      })
      .then(response=> {
        if(response.data.code == 0){
          this.rechargeData = response.data.data.records
          this.total2 = response.data.data.total
        }else{
          this.$message.error(response.data.message);
        }
      })
      .catch(error=> {
        console.log(error)
      })
      if(type == 1){
        this.axios({
          url: '/api/account/recharge/totalMoney', 
          method: 'get',
          params: {
            minCreateTime: this.rechargeObj.minCreateTime=='开始时间'?'':this.rechargeObj.minCreateTime,
            maxCreateTime: this.rechargeObj.maxCreateTime=='结束时间'?'':this.rechargeObj.maxCreateTime,
          }
        })
        .then(response=> {
          if(response.data.code == 0){
            this.totalPrice2 = response.data.data.money
          }else{
            this.$message.error(response.data.message);
          }
        })
        .catch(error=> {
          console.log(error)
        })
      }
    },
    contactUs() {
      this.rechargeModal = false
    },
    hasKnown() {
      this.rechargeModal = false
    },
    activateChannel() {
      this.$parent.jumpTo('pathManage');
    },
    onShowSizeChange1(current, pageSize) {
      this.consumptionObj.current = current
      this.consumptionObj.size = pageSize
      this.queryConsumptionData(2)
    },
    onChangeSample1(value) {
      this.consumptionObj.current = value
      this.queryConsumptionData(2)
    },
    onShowSizeChange2(current, pageSize) {
      this.rechargeObj.current = current
      this.rechargeObj.size = pageSize;
      this.queryRechargeData(2)
    },
    onChangeSample2(value) {
      this.rechargeObj.current = value
      this.queryRechargeData(2)
    },
    getCurrentDate(format) {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth();//得到月份
      var date = now.getDate();//得到日期
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      var time = "";
      //开始时间
      if(format==1){
        var date1 = new Date();
        var date2 = new Date(date1);
        date2.setDate(date1.getDate() - 30);
        time = `${date2.getFullYear()}-${date2.getMonth() + 1<10?`0${date2.getMonth() + 1}`:date2.getMonth() + 1}-${date2.getDate()}`;
      }
      //结束时间
      else if(format==2){
        time = year + "-" + month + "-" + date
      }
      return time;
    },
    downloadExcel() {
      this.axios(
        {
          method:'get',
          url:'/api/account/costRecord/list/export', 
          responseType: 'arraybuffer',
          params:{
            type: this.consumptionObj.type=='全部'?'':this.consumptionObj.type,
            minCreateTime: this.consumptionObj.minCreateTime=='开始时间'?'':this.consumptionObj.minCreateTime,
            status: this.consumptionObj.status=='全部'?'':this.consumptionObj.status,
            maxCreateTime: this.consumptionObj.maxCreateTime=='结束时间'?'':this.consumptionObj.maxCreateTime
          } 
        }
      )
      .then(response=> {
        this.download(response.data)
      })
      .catch(error=> {
        console.log(error)
      })
    },
    download(data) {
      if (!data) {
          return
      }
      const url = window.URL.createObjectURL(new Blob([data]))
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', '消费记录.csv')
      document.body.appendChild(link)
      link.click()
      URL.revokeObjectURL(link.href) // 释放URL 对象
      document.body.removeChild(link)
      link = null
    },
    queryDetail(text, detail) {
      console.log(text)
      this.ifShowCostDetail = true
      this.costDetailData = detail
    },
    hideCostDetail() {
      this.ifShowCostDetail = false
    }
  },
  mounted: function() {
    this.sessionData('set','leftNavItem','myAccount');
    this.rechargeObj.minCreateTime = this.getCurrentDate(1)
    this.rechargeObj.maxCreateTime = this.getCurrentDate(2)
    this.consumptionObj.minCreateTime = this.getCurrentDate(1)
    this.consumptionObj.maxCreateTime = this.getCurrentDate(2)
    this.viewMonth('COST')
    this.queryAccountBalance()
    this.queryChanneloverview()
    this.queryConsumptionData(1)
    this.queryRechargeData(1)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped  lang="less">
  .my-account{
    .account-head{
      height: 260px;
      display: flex;
      .balance{
        width: 300px;
        background: #fff;
        border-radius: 4px;
        .title{
          color: rgba(51, 51, 51, 1);
          font-size: 18px;
        }
        .credit{
          color: rgba(170, 170, 170, 1);
          font-size: 14px;
          padding:0 0 0 24px;
        }
      }
      .survey{
        flex: 1;
        background: #fff;
        margin: 0 16px;
        border-radius: 4px;
      }
      .bill{
        flex: 1;
        background: #fff;
        border-radius: 4px;
        .title{
          font-size: 18px;
          .month{
            color: rgba(51, 51, 51, 1);
          }
          div{
            float: right;
            border-radius: 4px;
            overflow: hidden;
            span{
              display: inline-block;
              margin-left: 24px;
              text-align: center;
              line-height: 28px;
              color: rgba(80, 80, 80, 1);
              font-size: 14px;
              cursor: pointer;
            }
            span.active{
              color: rgba(34, 215, 187, 1);
              border-bottom:4px solid rgba(34, 215, 187, 1);
            }
          }
        }
      }
    }
    .account-body{
      margin-top: 16px;
      background: #fff;
      .content-tab{
        height: 100%;
        overflow-y: auto;
        // padding: 24px;
        .tab-title{
          span{
            display: inline-block;
            height: 35px;
            line-height: 25px;
            color: rgba(51, 51, 51, 1);
            font-size: 16px;
            margin-right: 48px;
            cursor: pointer;
          }
          span.active{
            color: rgba(34, 215, 187, 1);
            border-bottom: 4px solid rgba(34, 215, 187, 1);
          }
        }
      }
    }
  }
</style>
